import React, { useContext, useEffect, useState } from 'react';
import { AiOutlineFileExcel, AiOutlinePrinter } from 'react-icons/ai';
import { Link, useNavigate } from 'react-router-dom';
import { LoginContext } from '../../../reactcontext/ReactContext';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import logo from '../../../assets/logo.avif';

const Balances = () => {
  const years = ["All Years", 2024, 2025, 2026];
  const apiUrl = process.env.REACT_APP_API_URL
  const { loginInfo } = useContext(LoginContext);
  const navigate = useNavigate();
  const [payments, setPayments] = useState([])
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(true)
  const [selectedYear, setSelectedYear] = useState(getCurrentYear());
  const [flattenedData, setFlattenedData] = useState([])


  useEffect(() => {

    !loginInfo.login && navigate("/")
    
  }, [loginInfo])

  useEffect(() => {
    axios.get(`${apiUrl}/payment/getAllPaymentsWithBalance`, {
        headers: {
          loginToken: localStorage.getItem("loginToken")
        }
    })
    .then(res => {
      if (res.data.error) {
        setErrorMessage(res.data.error);
      } else {
        // Filter valid records: must have year, passportNumber, fullName and be valid objects
        const validPayments = (res.data || []).filter(payment =>
          payment &&
          typeof payment === 'object' &&
          payment.year &&
          payment.year !== 'N/A' &&
          payment.passportNumber &&
          payment.passportNumber !== 'N/A' &&
          payment.fullName &&
          payment.fullName !== 'N/A' &&
          parseFloat(payment.balance || 0) > 0
        );
        console.log('API response data:', res.data);
        console.log('Valid payments after filtering:', validPayments);
        setPayments(validPayments);
        // Default to "All Years"
        setSelectedYear("All Years");
        setSelectedPayments(validPayments);
        setFlattenedData(validPayments.map(item => ({
          passportNo: item.passportNumber,
          fullName: item.fullName,
          year: item.year,
          initialAmount: parseFloat(item.initialAmount || 0).toLocaleString(),
          totalPaid: parseFloat(item.totalPayments || 0).toLocaleString(),
          balance: parseFloat(item.balance || 0).toLocaleString()
        })));
      }
      setLoading(false);
    })
    .catch(err => {
        console.error("Error fetching payments:", err);
        setLoading(false);
    });
  }, []);

  useEffect(() => {
    console.log("Payments fetched from API:", payments);
  }, [payments]);

  const handleYearChange = (event) => {
    const selectedYearValue = event.target.value;
    setSelectedYear(selectedYearValue)
    selectYear(selectedYearValue)
  };

  function selectYear(year) {
    console.log('selectYear called with year:', year);
    console.log('payments array:', payments);
    console.log('payments length:', payments ? payments.length : 'undefined');
    
    setSelectedYear(year);
    
    if (!payments || !Array.isArray(payments)) {
      console.error('Payments is not an array or is null');
      setSelectedPayments([]);
      setFlattenedData([]);
      return;
    }
    
    let filteredPayments = [];
    
    try {
      for (let i = 0; i < payments.length; i++) {
        const val = payments[i];
        console.log('Processing item', i, ':', val);
        
        if (!val) {
          console.log('Item', i, 'is null/undefined, skipping');
          continue;
        }
        
        if (typeof val !== 'object') {
          console.log('Item', i, 'is not an object, skipping');
          continue;
        }
        
        if (!val.year) {
          console.log('Item', i, 'has no year property, skipping');
          continue;
        }
        
        if (val.year === 'N/A') {
          console.log('Item', i, 'has N/A year, skipping');
          continue;
        }
        
        console.log('Item', i, 'passed all checks, year:', val.year);
        
        if (parseFloat(val.balance || 0) <= 0) {
          continue;
        }

        if (year === "All Years") {
          if (years.includes(Number(val.year))) {
            filteredPayments.push(val);
            console.log('Added to filtered (All Years)');
          }
        } else {
          if (String(val.year) === String(year)) {
            filteredPayments.push(val);
            console.log('Added to filtered (specific year)');
          }
        }
      }
    } catch (error) {
      console.error('Error in selectYear loop:', error);
      filteredPayments = [];
    }
    
    console.log('Final filteredPayments:', filteredPayments);
    setSelectedPayments(filteredPayments);
    
    try {
      setFlattenedData(filteredPayments.map(item => ({
        passportNo: item.passportNumber || 'N/A',
        fullName: item.fullName || 'N/A',
        year: item.year || 'N/A',
        initialAmount: parseFloat(item.initialAmount || 0).toLocaleString(),
        totalPaid: parseFloat(item.totalPayments || 0).toLocaleString(),
        balance: parseFloat(item.balance || 0).toLocaleString()
      })));
    } catch (error) {
      console.error('Error setting flattenedData:', error);
      setFlattenedData([]);
    }
  }
  
  function getCurrentYear() {
    const currentDate = new Date();
    return String(currentDate.getFullYear());
  }

  useEffect(() => {
    !loginInfo.login && navigate('/');
  }, [loginInfo]);

    
  function getReadableTimestamp() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const readableTimestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return readableTimestamp;
  }

  const generateReport = (elementId) => {
    if (loading || flattenedData.length === 0) {
      alert('No data available to print...');
      return;
    }

    const element = document.getElementById(elementId);
    if (element) {
      // Remove padding classes that cause top gap
      element.classList.remove('p-5', 'px-5');
      
      // Create print-specific styles
      const printStyles = document.createElement('style');
      printStyles.innerHTML = `
        @media print {
          @page {
            margin: 0;
          }
          body {
            margin: 0 !important;
            padding: 0 !important;
          }
          body * { visibility: hidden; }
          #${elementId}, #${elementId} * { visibility: visible; }
          #${elementId} {
            margin: 0 !important;
            padding: 0 !important;
            font-size: 10px;
            overflow: visible !important;
            page-break-inside: avoid;
          }
          table {
            page-break-inside: avoid;
            width: 100%;
            border-collapse: collapse;
            margin-top: 0 !important;
            height: auto !important;
          }
          tr {
            page-break-inside: avoid;
          }
          th, td {
            padding: 1px !important;
            text-align: left;
            font-size: 10px;
          }
          .header {
            margin-bottom: 0 !important;
            padding-top: 0 !important;
          }
        }
      `;
      document.head.appendChild(printStyles);

      // Print with a small delay to ensure styles are applied
      setTimeout(() => {
        window.print();
      }, 100);

      // Remove print styles and restore classes after printing
      setTimeout(() => {
        document.head.removeChild(printStyles);
        element.classList.add('p-5', 'px-5');
      }, 1000);
    }
  };

  return (
    <div className='w-full flex h-full flex-col items-center justify-between relative gap-3'>
      <div className='self-start'>
        <Link to={'/dashboard'} className='text-yellow-700'>
          Dashboard
        </Link>
        {' > '}
        <Link to={'/reports'} className='text-yellow-700'>
          Reports
        </Link>
        {' > '}
        Balances
        </div>

        <div className='p-2 bg-dimWhite rounded-lg'>
        <label>Filter Year: </label>
        <select className='p-1 bg-gray-100' onChange={handleYearChange} value={selectedYear}>
          {years.map(val => (
            <option key={val} value={val}>{val}</option>
          ))}
        </select>
        </div>
      
      <div className='w-full flex justify-center mt-5 gap-2 p-2'>
        <button
          className={`p-2 gap-1 flex items-center justify-center text-[13pt] rounded-md shadow-lg font-light ${
            loading || flattenedData.length === 0
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-yellow-400 hover:bg-yellow-500'
          }`}
          onClick={() => generateReport('report-content')}
          disabled={loading || flattenedData.length === 0}
        >
          <AiOutlinePrinter fontSize={24} />
          Print
        </button>
        <CSVLink
          data={flattenedData}
          filename={`outstanding balances-${getReadableTimestamp()}`}
          className={`p-2 gap-1 flex items-center justify-center text-[13pt] rounded-md shadow-lg font-light ${
            flattenedData.length === 0 ? 'bg-gray-400 cursor-not-allowed' : 'bg-gray-400 hover:bg-gray-500'
          }`}
        >
          <AiOutlineFileExcel fontSize={24} />
          Export CSV
        </CSVLink>
      </div>


      <div id='report-content' className='flex flex-col w-full p-5 px-5'>
        <img src={logo} alt='Logo' className='self-center w-20' />
        <h1 className='text-[18pt] font-semibold self-center'>Rahman Group</h1>
        <h1 className='text-[14pt] self-center mt-2'>Report Listing- Outstanding Balances for {selectedYear}</h1>
        <div className='flex flex-wrap justify-start w-full gap-10 mt-5'>
          <p className='italic'>
            Report Printed By : <span className='font-bold'>{loginInfo.userDetails.firstName + ' ' + loginInfo.userDetails.lastName}</span>
          </p>
          <p className='italic'>
            Printed On : <span className='font-bold'>{getReadableTimestamp()}</span>
          </p>
          <p className='italic'>
            Signature : <span className='font-bold'>______________</span>
          </p>
        </div>
        <div className='w-full h-full overflow-auto'>
          <hr className='my-4'/>
          {loading ? (
            <p className='w-full h-full text-center text-lg py-5'>Fetching data... Please wait</p>
          ) : selectedPayments.length === 0 ? (
            <div className='w-full text-center text-lg py-5 gap-y-10 flex flex-col justify-center items-center'>
              <p>{`There are no valid payments for ${selectedYear}. Please add records in Record Payment for this year.`}</p>
            </div>
          ) : (
            <div className="overflow-x-auto mt-5">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">Passport No</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">Full Name</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">Year</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">Initial Amount</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">Total Paid</th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase">Outstanding Balance</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {selectedPayments
                    .filter(item => item && item.year && item.year !== 'N/A' && item.passportNumber && item.passportNumber !== 'N/A' && parseFloat(item.balance || 0) > 0)
                    .map((item, index) => (
                      <tr key={index}>
                        <td className="px-6 py-4 whitespace-nowrap">{item.passportNumber}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{item.fullName}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{item.year}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{parseFloat(item.initialAmount || 0).toLocaleString()}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{parseFloat(item.totalPayments || 0).toLocaleString()}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{parseFloat(item.balance || 0).toLocaleString()}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
     
    </div>
  );
};

export default Balances;
